import { render, staticRenderFns } from "./LawMediationResultList.vue?vue&type=template&id=1c93faa4&"
import script from "./LawMediationResultList.vue?vue&type=script&lang=js&"
export * from "./LawMediationResultList.vue?vue&type=script&lang=js&"
import style0 from "./LawMediationResultList.vue?vue&type=style&index=0&id=1c93faa4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports